import { render, staticRenderFns } from "./EditAttributesBox.vue?vue&type=template&id=58ab1bcb&scoped=true&"
import script from "./EditAttributesBox.vue?vue&type=script&lang=js&"
export * from "./EditAttributesBox.vue?vue&type=script&lang=js&"
import style0 from "./EditAttributesBox.vue?vue&type=style&index=0&id=58ab1bcb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ab1bcb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VIcon,VOverlay})
